export const FETCH_AUCTION_CENTER_DATA = "FETCH_AUCTION_CENTER_DATA";
export const FETCH_AUCTION_CENTER_DATA_SUCCESS =
  "FETCH_AUCTION_CENTER_DATA_SUCCESS";
export const FETCH_AUCTION_CENTER_DATA_FAILURE =
  "FETCH_AUCTION_CENTER_DATA_FAILURE";

export const FETCH_AUCTION_CENTER_HEADER_DATA =
  "FETCH_AUCTION_CENTER_HEADER_DATA";
export const FETCH_AUCTION_CENTER_HEADER_DATA_SUCCESS =
  "FETCH_AUCTION_CENTER_HEADER_DATA_SUCCESS";
export const FETCH_AUCTION_CENTER_HEADER_DATA_FAILURE =
  "FETCH_AUCTION_CENTER_HEADER_DATA_FAILURE";

export const BIDDER_CONFIRM = "BIDDER_CONFIRM";
export const BIDDER_CONFIRM_SUCCESS = "BIDDER_CONFIRM_SUCCESS";
export const BIDDER_CONFIRM_FAILURE = "BIDDER_CONFIRM_FAILURE";

export const BIDDER_IN = "BIDDER_IN";
export const BIDDER_IN_SUCCESS = "BIDDER_IN_SUCCESS";
export const BIDDER_IN_FAILURE = "BIDDER_IN_FAILURE";

export const BIDDER_OUT = "BIDDER_OUT";
export const BIDDER_OUT_SUCCESS = "BIDDER_OUT_SUCCESS";
export const BIDDER_OUT_FAILURE = "BIDDER_OUT_FAILURE";

export const FETCH_AUCTION_CENTER_DATA_API_CALL =
  "FETCH_AUCTION_CENTER_DATA_API_CALL";

export const CATELOG_FETCH_ALL_DATA = "CATELOG_FETCH_ALL_DATA";
export const CATELOG_FETCH_ALL_DATA_SUCCESS = "CATELOG_FETCH_ALL_DATA_SUCCESS";
export const CATELOG_FETCH_ALL_DATA_FAILURE = "CATELOG_FETCH_ALL_DATA_FAILURE";

export const CATELOG_SUBMIT_DATA = "CATELOG_SUBMIT_DATA";
export const CATELOG_SUBMIT_DATA_SUCCESS = "CATELOG_SUBMIT_DATA_SUCCESS";
export const CATELOG_SUBMIT_DATA_FAILURE = "CATELOG_SUBMIT_DATA_FAILURE";

export const GET_SUMMARY_OF_TEA_SOLD_DATA = "GET_SUMMARY_OF_TEA_SOLD_DATA";
export const GET_SUMMARY_OF_TEA_SOLD_DATA_SUCCESS =
  "GET_SUMMARY_OF_TEA_SOLD_DATA_SUCCESS";
export const GET_SUMMARY_OF_TEA_SOLD_DATA_FAILURE =
  "GET_SUMMARY_OF_TEA_SOLD_DATA_FAILURE";

export const GET_AUCTIONEER_MARKET_SUMMARY_DATA =
  "GET_AUCTIONEER_MARKET_SUMMARY_DATA";
export const GET_AUCTIONEER_MARKET_SUMMARY_DATA_SUCCESS =
  "GET_AUCTIONEER_MARKET_SUMMARY_DATA_SUCCESS";
export const GET_AUCTIONEER_MARKET_SUMMARY_DATA_FAILURE =
  "GET_AUCTIONEER_MARKET_SUMMARY_DATA_FAILURE";

export const GET_AUCTIONEER_MARKET_SUMMARY_WISE_DATA =
  "GET_AUCTIONEER_MARKET_SUMMARY_WISE_DATA";
export const GET_AUCTIONEER_MARKET_SUMMARY_WISE_DATA_SUCCESS =
  "GET_AUCTIONEER_MARKET_SUMMARY_WISE_DATA_SUCCESS";
export const GET_AUCTIONEER_MARKET_SUMMARY_WISE_DATA_FAILURE =
  "GET_AUCTIONEER_MARKET_SUMMARY_WISE_DATA_FAILURE";

export const GET_MARKET_SUMMARY_DATA = "GET_MARKET_SUMMARY_DATA";
export const GET_MARKET_SUMMARY_DATA_SUCCESS =
  "GET_MARKET_SUMMARY_DATA_SUCCESS";
export const GET_MARKET_SUMMARY_DATA_FAILURE =
  "GET_MARKET_SUMMARY_DATA_FAILURE";

export const GET_MY_PLANNER_DATA = "GET_MY_PLANNER_DATA";
export const GET_MY_PLANNER_DATA_SUCCESS = "GET_MY_PLANNER_DATA_SUCCESS";
export const GET_MY_PLANNER_DATA_FAILURE = "GET_MY_PLANNER_DATA_FAILURE";
export const GET_MY_PLANNER_EXPORT_DATA_SUCCESS =
  "GET_MY_PLANNER_EXPORT_DATA_SUCCESS";
export const MY_PLANNER_EXPORT_DATA_API_RESPONSE =
  "MY_PLANNER_EXPORT_DATA_API_RESPONSE";

export const CALL_FETCH_AUCTION_CENTER_DATA_API =
  "CALL_FETCH_AUCTION_CENTER_DATA_API";

export const GET_MY_CATALOG_DATA = "GET_MY_CATALOG_DATA";
export const GET_MY_CATALOG_DATA_SUCCESS = "GET_MY_CATALOG_DATA_SUCCESS";
export const GET_MY_CATALOG_DATA_FAILURE = "GET_MY_CATALOG_DATA_FAILURE";

export const REMOVE_FROM_MY_CATALOG_AUCTON_BID =
  "REMOVE_FROM_MY_CATALOG_AUCTON_BID";

export const ADD_TO_MY_CATALOG_AUCTON_BID = "ADD_TO_MY_CATALOG_AUCTON_BID";

export const GET_AND_SET_USER_WISE_DEFAULT_COLUMN_CONFIG =
  "GET_AND_SET_USER_WISE_DEFAULT_COLUMN_CONFIG";
export const GET_AND_SET_USER_WISE_DEFAULT_COLUMN_CONFIG_SUCCESS =
  "GET_AND_SET_USER_WISE_DEFAULT_COLUMN_CONFIG_SUCCESS";

export const BACKEND_NOTIFICATION_AVILABLE = "BACKEND_NOTIFICATION_AVILABLE";
export const GET_BACKEND_NOTIFICATION = "GET_BACKEND_NOTIFICATION";
